import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { CommittesRoutingModule } from './committes-routing.module';
import { CommittesListComponent } from './committes-list/committes-list.component';
import { CommittesCreateComponent } from './committes-create/committes-create.component';

@NgModule({
  declarations: [CommittesListComponent, CommittesCreateComponent],
  imports: [
    CommonModule,
    CommittesRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class CommittesModule { }
